export default __webpack_public_path__ + "static/pazarama-logo-c0151af59e0240fe13d7c6aa9899caa8.png";